import { Component } from '@angular/core';

@Component({
  selector: 'app-assests-landing-page',
  templateUrl: './assests-landing-page.component.html',
  styleUrls: ['./assests-landing-page.component.scss']
})
export class AssestsLandingPageComponent {

}
